import { initBoldTextFormatting } from './utils/boldTextFormatter';
// import { initSubscriptTextFormatting } from './utils/subscriptFormatter';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Initialize formatters
initBoldTextFormatting('font-bold');
// initSubscriptTextFormatting();

// Add route change detection for SPA navigation
if (typeof window !== 'undefined') {
  let lastUrl = window.location.href;

  // Set up a listener for route changes in SPAs
  const checkForRouteChanges = () => {
    // Check if URL has changed (indicating route change)
    if (lastUrl !== window.location.href) {
      // console.log('Route changed, will re-run formatters');
      lastUrl = window.location.href;

      // Wait for content to be rendered before formatting
      setTimeout(() => {
        // console.log('Running formatters after route change');
        initBoldTextFormatting('font-bold');
        // initSubscriptTextFormatting();
      }, 500); // Increased delay to ensure lazy components are loaded
    }
  };

  // Check periodically for route changes
  setInterval(checkForRouteChanges, 300);

  // Also listen for React's content load events
  window.addEventListener('load', () => {
    setTimeout(() => {
      initBoldTextFormatting('font-bold');
      // initSubscriptTextFormatting();
    }, 1000);
  });
}





const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
